/*
 * Module for the EmployerDirect Access Codes job criteria page
 */
rs.module("content/jobs/criteria/employerdirectaccesscodes",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        // Initialize the page
        function initialize(jsSelectors, deliveryMethodOptions, printers, preferredPrinter) {

            var criteria = $.js(jsSelectors.criteria);

            var assignAccessCodesCheckBox = criteria.js(jsSelectors.assignAccessCodesCheckBox);
            var generateLettersCheckBox = criteria.js(jsSelectors.generateLettersCheckBox);
            var generateLettersFilterContainer = criteria.js(jsSelectors.generateLettersFilterContainer);
            var employerGridContainer = criteria.js(jsSelectors.employerGridContainer);
            var allEmployersRadio = criteria.js(jsSelectors.allEmployersRadio);
            var selectedEmployersRadio = criteria.js(jsSelectors.selectedEmployersRadio);
            var newCodesRadio = criteria.js(jsSelectors.newCodesRadio);
            var skipReviewCheckBox = criteria.js(jsSelectors.skipReviewCheckBox);
            var deliveryMethodSelect = criteria.js(jsSelectors.deliveryMethodSelect);
            var printersSelect = criteria.js(jsSelectors.printersSelect);

            // Get Select Helper for Select Lists since we're updating their options and properties
            var deliveryMethodSelectHelper = selectHelper.getHelper(deliveryMethodSelect);
            var printersSelectHelper = selectHelper.getHelper(printersSelect);

            // Register assignAccessCodesCheckBox changed event
            assignAccessCodesCheckBox.change(onAssignAccessCodesChanged);

            // Register generateLettersCheckBox changed event
            generateLettersCheckBox.change(hideShowGenerateLettersFields);

            // Register radio button changed events
            allEmployersRadio.change(hideShowGenerateLettersFields);
            selectedEmployersRadio.change(hideShowGenerateLettersFields);
            newCodesRadio.change(hideShowGenerateLettersFields);

            // Register skipReviewCheckBox change event to enable/disable appropriate fields
            skipReviewCheckBox.change(enableDisableSkipReviewFields);

            // Enable or disable newCodesRadio based on assignAccessCodesCheckBox, and
            // check allEmployersRadio if newCodesRadio becomes enabled
            function onAssignAccessCodesChanged() {

                if (assignAccessCodesCheckBox.is(":checked")) {
                    newCodesRadio.prop('disabled', false);
                }
                else {
                    if (newCodesRadio.is(":checked")) {
                        allEmployersRadio.prop('checked', true);
                    }    
                    newCodesRadio.prop('disabled', true);       
                }
            }

            // Hide or show Generate Letters fields based on generateLettersCheckBox and radio button selections
            function hideShowGenerateLettersFields() {

                if (generateLettersCheckBox.is(":checked")) {

                    visibility.setVisible(employerGridContainer, selectedEmployersRadio.is(":checked"));
                    visibility.show(generateLettersFilterContainer);
                }
                else {
                    visibility.hide(employerGridContainer);
                    visibility.hide(generateLettersFilterContainer);
                }
            }

            // Enable or disable Skip Review fields based on skipReviewCheckBox
            function enableDisableSkipReviewFields() {

                if (skipReviewCheckBox.is(":checked")) {

                    //enable and re-populate delivery method select
                    deliveryMethodSelectHelper.setDisabled(false);
                    deliveryMethodSelectHelper.replaceOptions(deliveryMethodOptions);

                    //enable and re-populate printer select
                    printersSelectHelper.setDisabled(false);
                    printersSelectHelper.replaceOptions(printers);

                    // Since we have reloaded printers, we should again default to the user's preferred Printer
                    if (preferredPrinter != '') {
                        printersSelectHelper.setValue(preferredPrinter);
                    }
                }
                else {
                    //disable and clear delivery method select
                    deliveryMethodSelectHelper.clearOptions();
                    deliveryMethodSelectHelper.setDisabled(true);

                    //disable and clear printer select
                    printersSelectHelper.clearOptions();
                    printersSelectHelper.setDisabled(true);
                }
            }
        }
    
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);